export default [
    {
        title: 'My Personal Website',
        display: true,
        link: 'https://michaeldsilva.com',
        linkDisplay: 'michaeldsilva.com',
        code: 'https://github.com/michaelddsilva/michaelddsilva.github.io',
        repo: 'michaelddsilva.github.io',
        status: 'On Going',
        img: [
            'img/project_images/m-icon.png', 
            'img/project_images/vue.png',
            'img/project_images/BootstrapVue.png'
        ],
        description: [
            'I started this site in Febuary of 2019 and have been updating it with my recent experiences, and tweaking it as I improve my experience as a web developer.',
            'This site is implemented with <a target="_blank" href="https://vuejs.org/">Vue.js</a> and uses <a target="_blank" href="https://bootstrap-vue.js.org/">BootstrapVue</a>.',
            'The icons i\'m using in site sections are from <a target="_blank" href="https://icons8.com">Icons8</a>.',
        ]
    },
    {
        title: 'Capstone Project',
        display: true,
        link: '',
        linkDisplay: '',
        code: '',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/react.png',
            'img/project_images/flask.png',
            'img/project_images/python.png',
            'img/project_images/leaflet.svg',
        ],
        description: [
            'Worked on a year long capstone project with three other software engineering students.',
            'This project consists of a react web app that connects to a flask server to retrieve and render JSON data based on input from user interacting with a leafet component.'
        ]
    },
    {
        title: 'Cold Crash',
        display: true,
        link: '',
        linkDisplay: '',
        code: '',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/c_sharp.png',
            'img/project_images/unity.png' 
        ],
        description: [
            'This  game" was created in collaboration with three other software engineering students using <a target="_blank" href="https://unity.com/products/unity-teams">Unity Teams</a>.',
            'The game\'s scripts were coded in C# and the assets and scenes were created in <a target="_blank" href="https://unity.com/" target="_blank">Unity</a>.',
        ]
    },
    {
        title: 'Shoot \'em up Game',
        display: true,
        link: '/spacegame/',
        linkDisplay: 'michaeldsilva.com/spacegame',
        code: '',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/c_sharp.png',
            'img/project_images/unity.png' 
        ],
        description: [
            'This "shoot \'em up game" was created in collaboration with two other software engineering students.',
            'The game\'s scripts were coded in C# and the assets and scenes were created in <a target="_blank" href="https://unity.com/" target="_blank">Unity</a>.',
            'NOTE: The game will automatically open in full screen and the quit game button will cause the game to freeze.',
        ]
    },
    {
        title: 'Maze Runner Game',
        display: true,
        link: '/mazerunnergame/',
        linkDisplay: 'michaeldsilva.com/mazerunnergame',
        code: 'https://github.com/michaelddsilva/maze-runner-game',
        repo: 'maze-runner-game',
        status: 'Complete',
        img: [
            'img/project_images/c_sharp.png',
            'img/project_images/unity.png' 
        ],
        description: [
            'This "Maze Runner" game was created for a game programming course.',
            'The game\'s scripts were coded in C# and the assets and scenes were created in <a target="_blank" href="https://unity.com/" target="_blank">Unity</a>.',
            'NOTE: The game will automatically open in full screen and the quit game button will cause the game to freeze.',
        ]
    },
    {
        title: 'Full Stack Web Application',
        display: true,
        link: '',
        linkDisplay: 'link',
        code: 'https://github.com/michaelddsilva/michaelddsilva.github.io',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/mongodb.png', 
            'img/project_images/angular.png',
            'img/project_images/nodejs.png'
        ],
        description: [
            'The Full Stack Web App was created with the MEAN (MongoDB, Express, Angular and Node.js) stack.',
            'The web app was created for a final project for Web Technologies course.',
            'The multi-page app uses the Angular framework and connects to a MongoDB database.',
        ]
    },
    {
        title: 'Backend for Mobile Application',
        display: true,
        link: 'https://github.com/michaelddsilva/runnup-server',
        linkDisplay: 'repo',
        code: 'https://github.com/michaelddsilva/michaelddsilva.github.io',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/mongodb.png', 
            'img/project_images/nodejs.png'
        ],
        description: [
            'Designed a mobile application with three other engineering students.',
            'Designed and implemented the server and DB logic for the server (Node.js, Express, MongoDB)',
            'This server was designed to be used a run planner/tracker application, but it does have some functionalities that could be used in any application.'
        ]
    },
    {
        title: 'Relational DB Application',
        display: true,
        link: '',
        linkDisplay: '',
        code: 'https://github.com/michaelddsilva/michaelddsilva.github.io',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/mysql.png', 
            'img/project_images/php.png',
        ],
        description: [
            'This application was created for a Database Management Systems course project.',
            'Created a relational database (DB) application with PHP that accesses a MySQL database through SQL commands.',
        ]
    },
    {
        title: 'Mobile Android Application',
        display: true,
        link: '',
        linkDisplay: '',
        demo: 'https://www.youtube.com/watch?v=z14ogKdjQAg&t=1s',
        code: 'https://github.com/michaelddsilva/michaelddsilva.github.io',
        repo: '',
        status: 'Complete',
        img: [
            'img/project_images/android.png', 
            'img/project_images/java.png',
            'img/project_images/firebase.png',
        ],
        description: [
            'This application was created for a Software Engineering Design course with four other software engineering students.',
            'A sleep tracker to keep you off your phone at night. Senses phone activity during sleep hours and scores your sleep pattern',
            'The application was created in Android Studio and connects to a <a target="_blank" href="https://firebase.google.com/">Google Firebase</a> database.',
        ]
    },
    {
        title: 'Computer Vision Project',
        display: false,
        link: '',
        linkDisplay: '',
        code: '',
        repo: '',
        status: 'In Progress',
        img: [
            'img/project_images/tensorflow.png', 
            'img/project_images/python.png',
            'img/project_images/googlecolaboratory.png',
        ],
        description: [
            'Working on a medical imaging AI project that uses image segmentation.',
            'This project is being completed in a team of five with diverse backgrounds in software engineering, computer science, and medical science.',
        ]
    },
    {
        title: 'Personal Site',
        display: false,
        link: 'https://briannadsilva.com',
        linkDisplay: 'briannadsilva.com',
        code: 'https://github.com/briannadsilva/briannadsilva.github.io',
        repo: 'briannadsilva.github.io',
        status: 'Work In Progress',
        img: [
            'img/project_images/b-icon.png', 
            'img/project_images/bootstrap.png', 
        ],
        description: [
            'Working on a personal site for my sister, and teaching her web development skills.',
            'This site uses <a target="_blank" href="https://getbootstrap.com/">Bootstrap</a>.',
        ]
    },
    {
        title: 'Sketchpad Web App',
        display: true,
        link: '/sketchpad',
        linkDisplay: 'michaeldsilva.com/sketchpad',
        code: 'https://github.com/michaelddsilva/sketchpad',
        repo: 'sketchpad',
        status: 'Complete',
        img: [
            'img/project_images/vue.png',
            'img/project_images/fabricjs.png',
        ],
        description: [
            'Made a sketchpad web app for my Human Computer Interfaces course.',
            'This vue web app is implemented with <a target="_blank" href="http://fabricjs.com/">fabricjs</a>',
            'NOTE: This vue web app is only optimized for desktop',
        ]
    },
    {
        title: 'Cipher Checker App',
        display: true,
        link: '/cipher-checker',
        linkDisplay: 'michaeldsilva.com/cipher-checker',
        code: 'https://github.com/michaelddsilva/cipher-checker',
        repo: 'cipher-checker',
        status: 'Complete',
        img: [
            'img/project_images/vue.png',
        ],
        description: [
            'Made a cipher-checker web app.',
            'This app will allow the user to play around with encryption and decrpytion using caesar, vigenère, or enigma ciphers.',
        ]
    },
]